
@if (displayOverlappingPeriodsWarning) {
  <t4-page-warning warning="COMPONENTS.MANAGE-EVENT-SALE-CATEGORY-STATES.OVERLAPWARNING"></t4-page-warning>
}

<t4-list-view #listVw [options]="listOptions" (onDataRequest)="OnDataRequest($event)">

  <ng-container *t4ListActions>

    @if (!isInArchiveMode) {
      <div class="object-actions bg-white text-end">
        <button (click)="addNewState()" class="btn btn-primary border btn-small" type="button"><i class="pd-x-5 far fa-plus-square"></i> {{ 'GENERIC.BUTTON.ADDNEW' | translate}}</button>
      </div>
    }

  </ng-container>

  <ng-container *t4ListItem="let item">


    @if (item.IsVoidState) {
      <td colspan="4">{{ 'COMPONENTS.MANAGE-EVENT-SALE-CATEGORY-STATES.CUSTOM-BUTTON-STATE-LIST.NO-ITEMS-TEXT' | translate }}  </td>
    }

    @if (!item.IsVoidState) {
      <ng-template #standard>
        <td>   {{ 'CUSTOM.BUTTON.STATE.LIST.STANDARD' | translate}} </td>
      </ng-template>
      <td>{{ item !== null ? item.TranslationCode : this.translate.instant('COMPONENTS.MANAGE-EVENT-SALE-CATEGORY-STATES.CUSTOM-BUTTON-STATE-LIST.CALCULATED') }}</td>
      @if (item !== null) {
        <td >{{ getButtonActionType(item) }} </td>
      }
      @if (item !== null) {
        <td>{{ getButtonStyle(item) }}</td>
      }
      <td>{{ item.Action | replaceOnEmpty }}</td>
    }


    <td>{{ item.ActiveFrom | localDateTime | replaceOnEmpty }}</td>
    <td>{{ item.ActiveTill | localDateTime | replaceOnEmpty }}</td>

    <td class="grid-action" >
      @if (!item.IsVoidState) {
        <button (click)="modifyExistingState(item)" type="button" class="btn btn-grid btn-round mdi mdi-info mdi-lead-pencil"></button>
        @if (!isInArchiveMode) {
          <button (click)="deleteState(item)" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline"></button>
        }
      }
    </td>


  </ng-container>

</t4-list-view>

